import * as m from '@staiter/i18n';
import { StateColorToken } from '@staiter/shared/task-module';
import styles from './KanbanColorPicker.module.css';

export type KanbanColorPickerProps = {
  value: StateColorToken;
  onChange: (next: StateColorToken) => void;
};

/**
 * KanbanColorPicker — 12 swatches из --column-color-* палитры (FE-S12.2-11).
 * Selected: ring 2px --text-primary.
 */
export function KanbanColorPicker({ value, onChange }: KanbanColorPickerProps): JSX.Element {
  return (
    <div className={styles.grid} role="radiogroup" aria-label={m.tm_kanban_column_color()}>
      {StateColorToken.options.map((token) => (
        <button
          key={token}
          type="button"
          role="radio"
          aria-checked={value === token}
          aria-label={token}
          className={[styles.swatch, value === token ? styles.selected : ''].join(' ')}
          style={{ background: `var(--column-color-${token})` }}
          onClick={() => onChange(token)}
        />
      ))}
    </div>
  );
}
